// Bundle expansion configuration
// Maps bundle variant IDs to their component variant IDs
// Updated: 2026-03-23 - Added Spring/Summer/Mother's/Father's Day and Spring & Summer Bundles
const BUNDLE_CONFIGS = {
  '53264633102646': { // Christmas Bundle - Classic, Best Sellers (Inserts Only)
    components: [
      { variantId: '49512249950518', quantity: 1 }, // Happy Thanksgiving Bountiful Fall Yardsy Sign
      { variantId: '49416319336758', quantity: 1 }, // Off White Merry Christmas Yardsy Sign
      { variantId: '51282228969782', quantity: 1 }, // Happy New Year Yardsy Sign
      { variantId: '51302687572278', quantity: 1 }  // Welcome Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268713275702': { // New Bundle (Inserts Only)
    components: [
      { variantId: '52360467710262', quantity: 1 },
      { variantId: '52462625849654', quantity: 1 },
      { variantId: '51302687637814', quantity: 1 },
      { variantId: '52492713394486', quantity: 1 }
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268752335158': { // Holiday Bundle
    components: [
      { variantId: '50861055017270', quantity: 1 }, // Gobble 'Til You Wobble Yardsy Sign
      { variantId: '52462625718582', quantity: 1 }, // Have A Holly Jolly Christmas Yardsy Sign
      { variantId: '52462828880182', quantity: 1 }, // Let It Snow Yardsy Sign
      { variantId: '51282229035318', quantity: 1 }  // New Year New Adventure Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268787790134': { // Bundle
    components: [
      { variantId: '52360467841334', quantity: 1 }, // Happy Thanksgiving Pumpkin Arrangement Yardsy Sign
      { variantId: '51185325211958', quantity: 1 }, // Happy Hanukkah Yardsy Sign
      { variantId: '51302687473974', quantity: 1 }, // Winter Cardinals Yardsy Sign
      { variantId: '51282228969782', quantity: 1 }  // Happy New Year Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268810006838': { // Bundle
    components: [
      { variantId: '51184087826742', quantity: 1 }, // Happy Challah-Days Yardsy Sign
      { variantId: '51302687637814', quantity: 1 }, // Winter Snowman Yardsy Sign
      { variantId: '52492713394486', quantity: 1 }, // Happy New Year Confetti Yardsy Sign
      { variantId: '52360467710262', quantity: 1 }  // Gobble Gobble Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268829536566': { // Bundle
    components: [
      { variantId: '52360467743030', quantity: 1 }, // Floral Gather Yardsy Sign
      { variantId: '51134370447670', quantity: 1 }, // Happy Kwanzaa Kinara Yardsy Sign
      { variantId: '52492713394486', quantity: 1 }, // Happy New Year Confetti Yardsy Sign
      { variantId: '51302687605046', quantity: 1 }  // Cozy Winter Cabin Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268843102518': { // Bundle
    components: [
      { variantId: '50861055017270', quantity: 1 }, // Gobble 'Til You Wobble Yardsy Sign
      { variantId: '52462625849654', quantity: 1 }, // Ho Ho Ho! Santa Yardsy Sign
      { variantId: '52492713394486', quantity: 1 }, // Happy New Year Confetti Yardsy Sign
      { variantId: '51492602380598', quantity: 1 }  // Happy Valentine's Day Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268854833462': { // Bundle
    components: [
      { variantId: '52492713394486', quantity: 1 }, // Happy New Year Confetti Yardsy Sign
      { variantId: '51492602380598', quantity: 1 }, // Happy Valentine's Day Yardsy Sign
      { variantId: '51613406986550', quantity: 1 }, // Mardi Gras Yardsy Sign
      { variantId: '51560253358390', quantity: 1 }  // Happy St. Patrick's Day Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53268857749814': { // Bundle
    components: [
      { variantId: '51560210497846', quantity: 1 }, // Hoppy Easter Garden Yardsy Sign
      { variantId: '51560253358390', quantity: 1 }, // Happy St. Patrick's Day Yardsy Sign
      { variantId: '51613406986550', quantity: 1 }, // Mardi Gras Yardsy Sign
      { variantId: '51492602380598', quantity: 1 }  // Happy Valentine's Day Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53269089812790': { // Bundle
    components: [
      { variantId: '52462625653046', quantity: 1 }, // Oh Come Let Us Adore Him Yardsy Sign
      { variantId: '51134370185526', quantity: 1 }, // Peace On Earth Yardsy Sign
      { variantId: '51560227733814', quantity: 1 }, // He is Risen Yardsy Sign
      { variantId: '51613483827510', quantity: 1 }  // Bless This Home Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53394923585846': { // Festive Holiday Bundle
    components: [
      { variantId: '53288104001846', quantity: 1 },
      { variantId: '53288125071670', quantity: 1 },
      { variantId: '53288130838838', quantity: 1 },
      { variantId: '51560253358390', quantity: 1 }
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53394884919606': { // Color Pop Holiday Bundle
    components: [
      { variantId: '53288125006134', quantity: 1 },
      { variantId: '53288130838838', quantity: 1 },
      { variantId: '51560253358390', quantity: 1 },
      { variantId: '51560231076150', quantity: 1 }
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53561398722870': { // Love & Luck Bundle 1 (Inserts Only)
    components: [
      { variantId: '53492808810806', quantity: 1 }, // Happy Valentine's Day Candy Yardsy Sign
      { variantId: '53492821721398', quantity: 1 }, // Happy St. Patrick's Day Shamrock Yardsy Sign
      { variantId: '53492801896758', quantity: 1 }, // Hello Spring Sun Yardsy Sign
      { variantId: '53492800454966', quantity: 1 }  // Happy Easter Playful Animals Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53561406488886': { // Religious Holiday Bundle (Inserts Only)
    components: [
      { variantId: '53288123990326', quantity: 1 }, // Floral Cross Yardsy Sign
      { variantId: '53554168955190', quantity: 1 }, // Hosanna Branch Yardsy Sign
      { variantId: '53492800586038', quantity: 1 }, // Christ Is Risen Cross Yardsy Sign
      { variantId: '52462625653046', quantity: 1 }  // Oh Come Let Us Adore Him Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53506558984502': { // Seasonal Welcome Bundle (Inserts Only)
    components: [
      { variantId: '51490470920502', quantity: 1 }, // Welcome Bouquet Yardsy Sign
      { variantId: '52462829011254', quantity: 1 }, // Welcome Gingerbread Yardsy Sign
      { variantId: '51881958146358', quantity: 1 }, // Welcome Ice Cream Yardsy Sign
      { variantId: '49600085295414', quantity: 1 }  // Welcome Pumpkins Autumn Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53528069079350': { // Traditional Welcome Bundle (Inserts Only)
    components: [
      { variantId: '51490470986038', quantity: 1 }, // Welcome To Our Home Yardsy Sign
      { variantId: '49026075394358', quantity: 1 }, // Simple Wreath Welcome Yardsy Sign
      { variantId: '51613483729206', quantity: 1 }, // Welcome Eucalyptus Wreath Yardsy Sign
      { variantId: '51490470920502', quantity: 1 }  // Welcome Bouquet Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53519831335222': { // Winter & Spring Bundle (Inserts Only)
    components: [
      { variantId: '51302687572278', quantity: 1 }, // Welcome Winter Yardsy Sign (Sky Blue)
      { variantId: '51302687408438', quantity: 1 }, // Snowy Forest Animals Yardsy Sign
      { variantId: '51560231076150', quantity: 1 }, // Hello Spring Floral Yardsy Sign
      { variantId: '51560231239990', quantity: 1 }  // Garden Butterfly Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53519824093494': { // Winter & Spring Holiday Bundle (Inserts Only)
    components: [
      { variantId: '51302687572278', quantity: 1 }, // Welcome Winter Yardsy Sign (Sky Blue)
      { variantId: '53288130838838', quantity: 1 }, // Happy Valentine's Day Heart Yardsy Sign
      { variantId: '51560231043382', quantity: 1 }, // Spring Has Sprung Yardsy Sign
      { variantId: '51560210530614', quantity: 1 }  // Happy Easter Eggs Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53616650125622': { // Welcome Dog Bundle 1 (Inserts Only)
    components: [
      { variantId: '51613422453046', quantity: 1 }, // Dog Vogue Yardsy Sign
      { variantId: '51560212955446', quantity: 1 }, // Sunflower Field Yardsy Sign
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '53572547543350', quantity: 1 }  // Eucalyptus Crest Welcome Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53616758751542': { // Welcome Dog Bundle 2 (Inserts Only)
    components: [
      { variantId: '52363356471606', quantity: 1 }, // Adopt Don't Shop Yardsy Sign
      { variantId: '51613422453046', quantity: 1 }, // Dog Vogue Yardsy Sign
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '51490470986038', quantity: 1 }  // Welcome To Our Home Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53619245187382': { // Patriotic Bundle (Inserts Only)
    components: [
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '51768918999350', quantity: 1 }, // God Bless America Framed Yardsy Sign
      { variantId: '51768918802742', quantity: 1 }, // Welcome Patriotic Fireworks Yardsy Sign
      { variantId: '51829123842358', quantity: 1 }  // Home Sweet Home Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53753102205238': { // Spring, Mother's Day, and Father's Day Bundle (Inserts Only)
    components: [
      { variantId: '51560231043382', quantity: 1 }, // Spring Has Sprung Yardsy Sign
      { variantId: '53492800454966', quantity: 1 }, // Happy Easter Playful Animals Yardsy Sign
      { variantId: '51768918835510', quantity: 1 }, // Happy Mother's Day Watercolor Floral Yardsy Sign
      { variantId: '51829121974582', quantity: 1 }  // Happy Father's Day Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53753095913782': { // Easter Celebration Bundle (Inserts Only)
    components: [
      { variantId: '51560210497846', quantity: 1 }, // Hoppy Easter Garden Yardsy Sign
      { variantId: '51560231076150', quantity: 1 }, // Hello Spring Floral Yardsy Sign
      { variantId: '51560227733814', quantity: 1 }, // He is Risen Yardsy Sign
      { variantId: '51560231043382', quantity: 1 }  // Spring Has Sprung Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53619278709046': { // Patriotic Holidays Bundle (Inserts Only)
    components: [
      { variantId: '51655439876406', quantity: 1 }, // Memorial Day Flag Yardsy Sign
      { variantId: '51829123875126', quantity: 1 }, // Fourth Of July Yardsy Sign
      { variantId: '52120591302966', quantity: 1 }, // Happy Labor Day Scene Yardsy Sign
      { variantId: '52360470790454', quantity: 1 }  // Happy Veterans Day Flags Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53624616911158': { // University of Tennessee Bundle (Inserts Only)
    components: [
      { variantId: '49485283885366', quantity: 1 }, // Tennessee Vols T Orange Yardsy Sign
      { variantId: '53513858613558', quantity: 1 }, // Tennessee T Go Vols Summit Blue Yardsy Sign
      { variantId: '50035195773238', quantity: 1 }, // Halloween Tennessee T Orange Yardsy Sign
      { variantId: '50035209535798', quantity: 1 }  // Christmas Tree Tennessee Holiday Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53619350864182': { // University of Michigan Bundle (Inserts Only)
    components: [
      { variantId: '51956862878006', quantity: 1 }, // Michigan M Blue Yardsy Sign
      { variantId: '51956863074614', quantity: 1 }, // Michigan M Go Blue Yardsy Sign
      { variantId: '52980007403830', quantity: 1 }, // Michigan Happy Halloween Skulls Yardsy Sign
      { variantId: '52980007436598', quantity: 1 }  // Michigan Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53796777099574': { // Spring, Summer, Mother's Day, Father's Day Bundle (Inserts Only)
    components: [
      { variantId: '51560231076150', quantity: 1 }, // Hello Spring Floral Yardsy Sign
      { variantId: '51768918835510', quantity: 1 }, // Happy Mother's Day Watercolor Floral Yardsy Sign
      { variantId: '51881958375734', quantity: 1 }, // Hello Summer Lemon Yardsy Sign
      { variantId: '51829121974582', quantity: 1 }  // Happy Father's Day Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53796805509430': { // Spring and Summer Bundle (Inserts Only)
    components: [
      { variantId: '51560231239990', quantity: 1 }, // Garden Butterfly Yardsy Sign
      { variantId: '51560231076150', quantity: 1 }, // Hello Spring Floral Yardsy Sign
      { variantId: '51881958375734', quantity: 1 }, // Hello Summer Lemon Yardsy Sign
      { variantId: '51881958146358', quantity: 1 }  // Welcome Ice Cream Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53851338211638': { // Mother's Day Preview Bundle (Inserts Only)
    components: [
      { variantId: '51768918835510', quantity: 1 }, // Happy Mother's Day Watercolor Floral Yardsy Sign
      { variantId: '51768918868278', quantity: 1 }, // Happy Mother's Day Bouquet Yardsy Sign
      { variantId: '51560231108918', quantity: 1 }, // Hello Spring Wreath Yardsy Sign
      { variantId: '51560230945078', quantity: 1 }  // Springtime Garden Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53902666727734': { // Mother's Interest Bundle (Inserts Only)
    components: [
      { variantId: '51768918835510', quantity: 1 }, // Happy Mother's Day Watercolor Floral Yardsy Sign
      { variantId: '51560212857142', quantity: 1 }, // Stop And Smell The Flowers Yardsy Sign
      { variantId: '53572547576118', quantity: 1 }, // Bow Border Welcome Yardsy Sign
      { variantId: '51560212824374', quantity: 1 }  // Garden Life Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53914608304438': { // Mother's Day Preview Bundle 2 (Inserts Only)
    components: [
      { variantId: '51768918868278', quantity: 1 }, // Happy Mother's Day Bouquet Yardsy Sign
      { variantId: '51768918835510', quantity: 1 }, // Happy Mother's Day Watercolor Floral Yardsy Sign
      { variantId: '51560231108918', quantity: 1 }, // Hello Spring Wreath Yardsy Sign
      { variantId: '53749339029814', quantity: 1 }  // Happy Mother's Day Flowers Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53967428124982': { // Memorial Day Patriotic Bundle (Inserts Only)
    components: [
      { variantId: '51655439876406', quantity: 1 }, // American Flag Yardsy Sign — Memorial Day
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '52249857261878', quantity: 1 }, // We Support Our Yardsy Sign — Veterans
      { variantId: '51829124006198', quantity: 1 }  // Let Freedom Ring Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53981315891510': { // Summer Kickoff Bundle (Inserts Only)
    components: [
      { variantId: '51881958441270', quantity: 1 }, // BBQ Time Yardsy Sign
      { variantId: '51881958342966', quantity: 1 }, // Hello Sweet Summertime Yardsy Sign
      { variantId: '51881958015286', quantity: 1 }, // Summer Vibes Yardsy Sign
      { variantId: '51881958080822', quantity: 1 } // Vacay Mode Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53979382874422': { // Texas A&M Christmas Bundle (Insert Bundles)
    components: [
      { variantId: '53473988804918', quantity: 1 }, // Texas A&M University Gig Em Aggies Maroon Yardsy Sign
      { variantId: '51734393028918', quantity: 1 }, // Texas A&M University Maroon Yardsy Sign
      { variantId: '52974255341878', quantity: 1 }, // Texas A&M Halloween Trick Or Treat Yardsy Sign
      { variantId: '52974255374646', quantity: 1 } // Texas A&M Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53979375796534': { // Penn State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51334529089846', quantity: 1 }, // Penn State Lion Mark Yardsy Sign
      { variantId: '51334528893238', quantity: 1 }, // Penn State Script Mark Yardsy Sign
      { variantId: '53023338496310', quantity: 1 }, // Penn State Halloween Trick Or Treat Yardsy Sign
      { variantId: '53023338398006', quantity: 1 } // Penn State Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53979360657718': { // Oklahoma Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51315280478518', quantity: 1 }, // Oklahoma Athletics Mark Crimson Yardsy Sign
      { variantId: '51315280511286', quantity: 1 }, // Oklahoma Boomer Sooner Wordmark Black Yardsy Sign
      { variantId: '52974226374966', quantity: 1 }, // Oklahoma Halloween Trick Or Treat Yardsy Sign
      { variantId: '52974226342198', quantity: 1 } // Oklahoma Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53979353645366': { // LSU Christmas Bundle (Inserts Only)
    components: [
      { variantId: '49145638846774', quantity: 1 }, // LSU Tiger Eye Yardsy Sign
      { variantId: '53502187864374', quantity: 1 }, // LSU Geaux Tigers Purple Yardsy Sign
      { variantId: '49972846231862', quantity: 1 }, // LSU Halloween Spooky Yardsy Sign
      { variantId: '50014377017654', quantity: 1 } // Merry Christmas LSU Ornaments Holiday Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53979279229238': { // Florida Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450401685814', quantity: 1 }, // Florida Gators Blue Yardsy Sign
      { variantId: '51450401653046', quantity: 1 }, // Florida Albert Gators White Yardsy Sign
      { variantId: '52974215135542', quantity: 1 }, // Florida Happy Halloween Skulls Yardsy Sign
      { variantId: '52974215201078', quantity: 1 } // Florida Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53978139951414': { // Clemson Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51449719095606', quantity: 1 }, // Clemson Paw Print Regalia Yardsy Sign
      { variantId: '51332913725750', quantity: 1 }, // Clemson Paw Wordmark Yardsy Sign
      { variantId: '52974195081526', quantity: 1 }, // Clemson Halloween Trick Or Treat Yardsy Sign
      { variantId: '52974195048758', quantity: 1 } // Clemson Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037329543478': { // Testing Bundler
    components: [
      { variantId: '54023606370614', quantity: 1 }, // Welcome Summer Vacation Yardsy Sign
      { variantId: '54023603257654', quantity: 1 }, // Welcome Spring Flowers Yardsy Sign
      { variantId: '54023602241846', quantity: 1 }, // Welcome Fall Leaf Garland Yardsy Sign
      { variantId: '54023601422646', quantity: 1 } // Watering Can Garden Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037478179126': { // testing again
    components: [
      { variantId: '54023596048694', quantity: 1 }, // Firefly Lake Yardsy Sign
      { variantId: '54023603257654', quantity: 1 }, // Welcome Spring Flowers Yardsy Sign
      { variantId: '54023602241846', quantity: 1 }, // Welcome Fall Leaf Garland Yardsy Sign
      { variantId: '54023601422646', quantity: 1 } // Watering Can Garden Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037517173046': { // Summer test bundle
    components: [
      { variantId: '53967735324982', quantity: 1 }, // Summer Paradise Yardsy Sign
      { variantId: '53967733555510', quantity: 1 }, // Summer Block Letters Yardsy Sign
      { variantId: '53967731327286', quantity: 1 }, // Life's A Beach Yardsy Sign
      { variantId: '53967727624502', quantity: 1 } // If Crabby Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037624914230': { // testing img creation
    components: [
      { variantId: '53997302382902', quantity: 1 }, // West Virginia Merry Christmas Yardsy Sign
      { variantId: '53967735324982', quantity: 1 }, // Summer Paradise Yardsy Sign
      { variantId: '53997292945718', quantity: 1 }, // Nebraska Merry Christmas Yardsy Sign
      { variantId: '53967733555510', quantity: 1 } // Summer Block Letters Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037988016438': { // testing again 123
    components: [
      { variantId: '53967721857334', quantity: 1 }, // Good Vibes Yardsy Sign
      { variantId: '53967720808758', quantity: 1 }, // Boho Sun Yardsy Sign
      { variantId: '53967720284470', quantity: 1 }, // Ahoy Yardsy Sign
      { variantId: '53967725265206', quantity: 1 } // Hello Summer Pool Floaties Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54039336780086': { // testingfromdesign.
    components: [
      { variantId: '51134370677046', quantity: 1 }, // Fa La La La La Yardsy Sign
      { variantId: '49600119177526', quantity: 1 }, // Fall Cornucopia Autumn Yardsy Sign
      { variantId: '49512004747574', quantity: 1 }, // Fall Farm House Landscape Yardsy Sign
      { variantId: '52251540095286', quantity: 1 } // Fall Flowers Custom Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54039810572598': { // Testing for meeting
    components: [
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '54023599128886', quantity: 1 }, // Patriotic Soaring Eagle Yardsy Sign
      { variantId: '54023596802358', quantity: 1 }, // Fireworks Show Yardsy Sign
      { variantId: '53967725265206', quantity: 1 } // Hello Summer Pool Floaties Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  // ── Backfilled 2026-05-20: 4-pack bundles that existed in Shopify but
  //    were missing from BUNDLE_CONFIGS (auto-discovered via dashboard
  //    orphan-bundle scan; components pulled from native productBundleComponents).
  '53600374817078': { // Faith Bundle (Inserts Only)
    components: [
      { variantId: '53288123990326', quantity: 1 }, // Floral Cross Yardsy Sign
      { variantId: '53554168889654', quantity: 1 }, // Be The Light Sun Yardsy Sign
      { variantId: '53554169053494', quantity: 1 }, // Faith Over Fear Yardsy Sign
      { variantId: '53554168922422', quantity: 1 } // God Is Good Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53600390611254': { // Nature Welcome Bundle (Inserts Only)
    components: [
      { variantId: '51622341509430', quantity: 1 }, // Cacti Welcome Custom Yardsy Sign
      { variantId: '51613483794742', quantity: 1 }, // Groovy Floral Welcome Yardsy Sign
      { variantId: '51490471117110', quantity: 1 }, // Poppy Flower Welcome Yardsy Sign
      { variantId: '51613483860278', quantity: 1 } // Tropical Welcome Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997676331318': { // Texas A&M Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '53473988804918', quantity: 1 }, // Texas A&M University Gig Em Aggies Maroon Yardsy Sign
      { variantId: '51734393028918', quantity: 1 }, // Texas A&M University Maroon Yardsy Sign
      { variantId: '52974255341878', quantity: 1 }, // Texas A&M Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997252968758', quantity: 1 } // Texas A&M Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997716570422': { // LSU Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '49145638846774', quantity: 1 }, // LSU Tiger Eye Yardsy Sign
      { variantId: '53502187864374', quantity: 1 }, // LSU Geaux Tigers Purple Yardsy Sign
      { variantId: '49972846231862', quantity: 1 }, // LSU Halloween Spooky Yardsy Sign
      { variantId: '53997251133750', quantity: 1 } // LSU Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997731021110': { // Oklahoma Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51315280478518', quantity: 1 }, // Oklahoma Athletics Mark Crimson Yardsy Sign
      { variantId: '51315280511286', quantity: 1 }, // Oklahoma Boomer Sooner Wordmark Black Yardsy Sign
      { variantId: '52974226374966', quantity: 1 }, // Oklahoma Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997252051254', quantity: 1 } // Oklahoma Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997742326070': { // Nebraska Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450551992630', quantity: 1 }, // Nebraska Huskers Red Yardsy Sign
      { variantId: '51450551894326', quantity: 1 }, // Nebraska N Mark Black Yardsy Sign
      { variantId: '53997287178550', quantity: 1 }, // Nebraska Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997292945718', quantity: 1 } // Nebraska Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997832995126': { // Nebraska Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51450551992630', quantity: 1 }, // Nebraska Huskers Red Yardsy Sign
      { variantId: '51450551894326', quantity: 1 }, // Nebraska N Mark Black Yardsy Sign
      { variantId: '53997287178550', quantity: 1 }, // Nebraska Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997251887414', quantity: 1 } // Nebraska Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997846495542': { // Florida Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51450401685814', quantity: 1 }, // Florida Gators Blue Yardsy Sign
      { variantId: '51450401653046', quantity: 1 }, // Florida Albert Gators White Yardsy Sign
      { variantId: '52974215135542', quantity: 1 }, // Florida Happy Halloween Skulls Yardsy Sign
      { variantId: '53997250576694', quantity: 1 } // Florida Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997857603894': { // Illinois Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51318299722038', quantity: 1 }, // Illinois Primary Mark Orange Yardsy Sign
      { variantId: '51318300082486', quantity: 1 }, // Illinois Helmet Mark White Yardsy Sign
      { variantId: '53997273809206', quantity: 1 }, // Illinois Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997276856630', quantity: 1 } // Illinois Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997874282806': { // Illinois Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51318299722038', quantity: 1 }, // Illinois Primary Mark Orange Yardsy Sign
      { variantId: '51318300082486', quantity: 1 }, // Illinois Helmet Mark White Yardsy Sign
      { variantId: '53997273809206', quantity: 1 }, // Illinois Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997251068214', quantity: 1 } // Illinois Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997902463286': { // Clemson Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51449719095606', quantity: 1 }, // Clemson Paw Print Regalia Yardsy Sign
      { variantId: '51332913725750', quantity: 1 }, // Clemson Paw Wordmark Yardsy Sign
      { variantId: '52974195081526', quantity: 1 }, // Clemson Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997250445622', quantity: 1 } // Clemson Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997935362358': { // TCU Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51340790432054', quantity: 1 }, // TCU Horned Frog Purple Yardsy Sign
      { variantId: '51340790268214', quantity: 1 }, // TCU Primary Mark Purple Yardsy Sign
      { variantId: '53997295173942', quantity: 1 }, // TCU Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997297107254', quantity: 1 } // TCU Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53997972062518': { // TCU Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51340790432054', quantity: 1 }, // TCU Horned Frog Purple Yardsy Sign
      { variantId: '51340790268214', quantity: 1 }, // TCU Primary Mark Purple Yardsy Sign
      { variantId: '53997295173942', quantity: 1 }, // TCU Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997252706614', quantity: 1 } // TCU Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53998011547958': { // Indiana Christmas Bundle (Inserts Only)
    components: [
      { variantId: '53391816786230', quantity: 1 }, // Indiana University Go Big Red Crimson Yardsy Sign
      { variantId: '53391816753462', quantity: 1 }, // Indiana University IU Crimson Yardsy Sign
      { variantId: '53391816818998', quantity: 1 }, // Indiana University Halloween Trick Or Treat Yardsy Sign
      { variantId: '53391816851766', quantity: 1 } // Indiana University Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53998029996342': { // Florida State University Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51924838351158', quantity: 1 }, // Florida State FSU Spear Yardsy Sign
      { variantId: '51924838416694', quantity: 1 }, // Florida State Seminoles Garnet Yardsy Sign
      { variantId: '53997271253302', quantity: 1 }, // Florida State Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997271974198', quantity: 1 } // Florida State Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '53998042743094': { // Florida State University Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51924838351158', quantity: 1 }, // Florida State FSU Spear Yardsy Sign
      { variantId: '51924838416694', quantity: 1 }, // Florida State Seminoles Garnet Yardsy Sign
      { variantId: '53997271253302', quantity: 1 }, // Florida State Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997250707766', quantity: 1 } // Florida State Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54023804682550': { // Welcome Seasons Motifs Bundle (Inserts Only)
    components: [
      { variantId: '54023603257654', quantity: 1 }, // Welcome Spring Flowers Yardsy Sign
      { variantId: '54023606370614', quantity: 1 }, // Welcome Summer Vacation Yardsy Sign
      { variantId: '54023602241846', quantity: 1 }, // Welcome Fall Leaf Garland Yardsy Sign
      { variantId: '54023606894902', quantity: 1 } // Welcome Winter Snowflakes Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54023810351414': { // Bestseller Nature Bundle (Inserts Only)
    components: [
      { variantId: '54023601422646', quantity: 1 }, // Watering Can Garden Yardsy Sign
      { variantId: '54023596048694', quantity: 1 }, // Firefly Lake Yardsy Sign
      { variantId: '54023600636214', quantity: 1 }, // Watercolor Butterfly Yardsy Sign
      { variantId: '54023600046390', quantity: 1 } // Springtime Sunflowers Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54023815495990': { // Bestseller Patriot Bundle (Inserts Only)
    components: [
      { variantId: '54023598309686', quantity: 1 }, // Land That I Love Patriotic Yardsy Sign
      { variantId: '54023599128886', quantity: 1 }, // Patriotic Soaring Eagle Yardsy Sign
      { variantId: '54023596802358', quantity: 1 }, // Fireworks Show Yardsy Sign
      { variantId: '54023597654326', quantity: 1 } // Land Of The Free Floral Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037720793398': { // Fall Bundle (Inserts Only)
    components: [
      { variantId: '54031497920822', quantity: 1 }, // Welcome Fall Wreath Border Yardsy Sign
      { variantId: '52249869418806', quantity: 1 }, // Happy Halloween Candy Yardsy Sign
      { variantId: '52360467677494', quantity: 1 }, // Turkey And Touchdowns Yardsy Sign
      { variantId: '52360467841334', quantity: 1 } // Happy Thanksgiving Pumpkin Arrangement Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54037721350454': { // School Bundle (Inserts Only)
    components: [
      { variantId: '54031497199926', quantity: 1 }, // First Day of School Yardsy Sign
      { variantId: '51655384301878', quantity: 1 }, // Congrats, You Did It Yardsy Sign
      { variantId: '53967725265206', quantity: 1 }, // Hello Summer Pool Floaties Yardsy Sign
      { variantId: '54031497560374', quantity: 1 } // Last Days of Summer Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54046800085302': { // University of Alabama Holiday Bundle (Inserts Only)
    components: [
      { variantId: '54037867102518', quantity: 1 }, // Alabama Stripes White Yardsy Sign
      { variantId: '54037867004214', quantity: 1 }, // Alabama Roll Tide Athletic Mark Crimson Yardsy Sign
      { variantId: '54037858353462', quantity: 1 }, // Alabama Halloween Trick Or Treat Yardsy Sign
      { variantId: '54037858386230', quantity: 1 } // Alabama Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049032732982': { // Texas Tech Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51593977659702', quantity: 1 }, // Texas Tech Red Yardsy Sign
      { variantId: '51593977823542', quantity: 1 }, // Texas Tech TT Black Yardsy Sign
      { variantId: '53997298090294', quantity: 1 }, // Texas Tech Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997299237174', quantity: 1 } // Texas Tech Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049035321654': { // Texas Tech Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51593977659702', quantity: 1 }, // Texas Tech Red Yardsy Sign
      { variantId: '51593977823542', quantity: 1 }, // Texas Tech TT Black Yardsy Sign
      { variantId: '53997298090294', quantity: 1 }, // Texas Tech Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997254574390', quantity: 1 } // Texas Tech Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049074741558': { // Tennessee Holiday Bundle (Inserts Only)
    components: [
      { variantId: '49485283885366', quantity: 1 }, // Tennessee Vols T Orange Yardsy Sign
      { variantId: '53513858613558', quantity: 1 }, // Tennessee T Go Vols Summit Blue Yardsy Sign
      { variantId: '54048976240950', quantity: 1 }, // Tennessee Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048976863542', quantity: 1 } // Tennessee Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049090076982': { // Auburn Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51924803387702', quantity: 1 }, // Auburn Tigers Eyes Yardsy Sign
      { variantId: '51924803354934', quantity: 1 }, // Auburn AU Tigers Yardsy Sign
      { variantId: '54048960905526', quantity: 1 }, // Auburn Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048962216246', quantity: 1 } // Auburn Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049092174134': { // Auburn Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51924803387702', quantity: 1 }, // Auburn Tigers Eyes Yardsy Sign
      { variantId: '51924803354934', quantity: 1 }, // Auburn AU Tigers Yardsy Sign
      { variantId: '54048960905526', quantity: 1 }, // Auburn Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048924008758', quantity: 1 } // Auburn Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049483948342': { // Spring and Summer Bundle (Inserts Only)
    components: [
      { variantId: '51560231076150', quantity: 1 }, // Hello Spring Floral Yardsy Sign
      { variantId: '51560231239990', quantity: 1 }, // Garden Butterfly Yardsy Sign
      { variantId: '53967725265206', quantity: 1 }, // Hello Summer Pool Floaties Yardsy Sign
      { variantId: '53967731327286', quantity: 1 } // Life's A Beach Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049484702006': { // Summer Hits Bundle (Inserts Only)
    components: [
      { variantId: '53967725265206', quantity: 1 }, // Hello Summer Pool Floaties Yardsy Sign
      { variantId: '53883619803446', quantity: 1 }, // Celebrating 250 Years Yardsy Sign
      { variantId: '53967720808758', quantity: 1 }, // Boho Sun Yardsy Sign
      { variantId: '53967733555510', quantity: 1 } // Summer Block Letters Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049488142646': { // Father’s Day Preview Bundle (Inserts Only)
    components: [
      { variantId: '51829121974582', quantity: 1 }, // Happy Father's Day Yardsy Sign
      { variantId: '51829121909046', quantity: 1 }, // Best Dad By Par Yardsy Sign
      { variantId: '51881958441270', quantity: 1 }, // BBQ Time Yardsy Sign
      { variantId: '49026219409718', quantity: 1 } // Gone Fishin' Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049488568630': { // Father’s Day Gift Bundle (Inserts Only)
    components: [
      { variantId: '53883625865526', quantity: 1 }, // Happy Father's Day Super Dad Yarsdy Sign
      { variantId: '51881958441270', quantity: 1 }, // BBQ Time Yardsy Sign
      { variantId: '51829121909046', quantity: 1 }, // Best Dad By Par Yardsy Sign
      { variantId: '48937634464054', quantity: 1 } // USA Flag Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54049488830774': { // Father’s Interest Bundle (Inserts Only)
    components: [
      { variantId: '51829121909046', quantity: 1 }, // Best Dad By Par Yardsy Sign
      { variantId: '51881958441270', quantity: 1 }, // BBQ Time Yardsy Sign
      { variantId: '51881958244662', quantity: 1 }, // Take Me to the Lake Yardsy Sign
      { variantId: '51882007953718', quantity: 1 } // Happy Campers Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154210836790': { // Alabama 2026 Season Games 1
    components: [
      { variantId: '54154016620854', quantity: 1 }, // Alabama V East Carolina Yardsy Sign
      { variantId: '54154018914614', quantity: 1 }, // Alabama V Kentucky Yardsy Sign
      { variantId: '54154018226486', quantity: 1 }, // Alabama V Florida State Yardsy Sign
      { variantId: '54154019733814', quantity: 1 } // Alabama V South Carolina Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154225385782': { // Auburn 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154020192566', quantity: 1 }, // Auburn V Baylor Yardsy Sign
      { variantId: '54154021404982', quantity: 1 }, // Auburn V Southern Miss Yardsy Sign
      { variantId: '54154020847926', quantity: 1 }, // Auburn V Florida Yardsy Sign
      { variantId: '54154022158646', quantity: 1 } // Auburn V Vanderbilt Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154228728118': { // Clemson 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154026189110', quantity: 1 }, // Clemson V Lsu Yardsy Sign
      { variantId: '54154024911158', quantity: 1 }, // Clemson V Georgia Southern Yardsy Sign
      { variantId: '54154028253494', quantity: 1 }, // Clemson V North Carolina Yardsy Sign
      { variantId: '54154023665974', quantity: 1 } // Clemson V Cal Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154230726966': { // Florida 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154032808246', quantity: 1 }, // Florida V Florida Atlantic Yardsy Sign
      { variantId: '54154031759670', quantity: 1 }, // Florida V Campbell Yardsy Sign
      { variantId: '54154029793590', quantity: 1 }, // Florida V Auburn Yardsy Sign
      { variantId: '54154034577718', quantity: 1 } // Florida V Ole Miss Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154232332598': { // Michigan 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154043031862', quantity: 1 }, // Michigan V Western Michigan Yardsy Sign
      { variantId: '54154040770870', quantity: 1 }, // Michigan V Oklahoma Yardsy Sign
      { variantId: '54154041884982', quantity: 1 }, // Michigan V Utep Yardsy Sign
      { variantId: '54154036085046', quantity: 1 } // Michigan V Iowa Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154235642166': { // Nebraska 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154051354934', quantity: 1 }, // Nebraska V Ohio Yardsy Sign
      { variantId: '54154044834102', quantity: 1 }, // Nebraska V Bowling Green Yardsy Sign
      { variantId: '54154048569654', quantity: 1 }, // Nebraska V North Dakota Yardsy Sign
      { variantId: '54154046800182', quantity: 1 } // Nebraska V Michigan State Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154240885046': { // Oklahoma 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154072162614', quantity: 1 }, // Oklahoma V Utep Yardsy Sign
      { variantId: '54154068525366', quantity: 1 }, // Oklahoma V Michigan Yardsy Sign
      { variantId: '54154070556982', quantity: 1 }, // Oklahoma V New Mexico Yardsy Sign
      { variantId: '54154060235062', quantity: 1 } // Oklahoma V Georgia Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54154244030774': { // Texas Tech 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54154073145654', quantity: 1 }, // Texas Tech V Abilene Christian Yardsy Sign
      { variantId: '54154084778294', quantity: 1 }, // Texas Tech V Oregon State Yardsy Sign
      { variantId: '54154079469878', quantity: 1 }, // Texas Tech V Houston Yardsy Sign
      { variantId: '54154090742070', quantity: 1 } // Texas Tech V Sam Houston Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54177686552886': { // Penn State 2026 Season Games 1 (Inserts Only)
    components: [
      { variantId: '54177672429878', quantity: 1 }, // Penn State V Marshall Yardsy Sign
      { variantId: '54177676067126', quantity: 1 }, // Penn State V Temple Yardsy Sign
      { variantId: '54177669087542', quantity: 1 }, // Penn State V Buffalo Yardsy Sign
      { variantId: '54177676591414', quantity: 1 } // Penn State V Wisconsin Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54228697415990': { // Fall Holidays Bundle
    components: [
      { variantId: '54149253234998', quantity: 1 }, // Welcome Fall Arrangement Yardsy Sign
      { variantId: '52249869418806', quantity: 1 }, // Happy Halloween Candy Yardsy Sign
      { variantId: '54149176951094', quantity: 1 }, // Happy Thanksgiving Wreath Yardsy Sign
      { variantId: '52360470790454', quantity: 1 } // Happy Veterans Day Flags Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54228748370230': { // Fall & Halloween Bundle (Inserts Only)
    components: [
      { variantId: '54149174755638', quantity: 1 }, // Happy Halloween Trick Or Treaters Yardsy Sign
      { variantId: '52249869484342', quantity: 1 }, // Trick Or Treat Ghosts Yardsy Sign
      { variantId: '52360467743030', quantity: 1 }, // Floral Gather Yardsy Sign
      { variantId: '54149172330806', quantity: 1 } // Folk Art Turkey Happy Thanksgiving Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54228759937334': { // Decorative Fall & Spooky Halloween Bundle (Inserts Only)
    components: [
      { variantId: '49511963459894', quantity: 1 }, // Have a Blessed Fall Yardsy Sign
      { variantId: '51001285902646', quantity: 1 }, // Thanksgiving Flowers Yardsy Sign
      { variantId: '54149172592950', quantity: 1 }, // Happy Halloween Harvest Moon Yardsy Sign
      { variantId: '54149176000822', quantity: 1 } // Happy Thanksgiving Fall Cornucopia Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54254492320054': { // School, Fall, & Halloween Bundle (Inserts Only)
    components: [
      { variantId: '54221344670006', quantity: 1 }, // First Day Of Elementary School Yardsy Sign
      { variantId: '54149253234998', quantity: 1 }, // Welcome Fall Arrangement Yardsy Sign
      { variantId: '52249864962358', quantity: 1 }, // Autumn Leaves & Pumpkins Please! Yardsy Sign
      { variantId: '54149174755638', quantity: 1 } // Happy Halloween Trick Or Treaters Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54254493892918': { // Middle School, Fall, & Halloween Bundle (Inserts Only)
    components: [
      { variantId: '54221348536630', quantity: 1 }, // First Day Of Middle School Yardsy Sign
      { variantId: '54149253234998', quantity: 1 }, // Welcome Fall Arrangement Yardsy Sign
      { variantId: '50014431904054', quantity: 1 }, // Pumpkin Patch Fall Yardsy Sign
      { variantId: '52249869418806', quantity: 1 } // Happy Halloween Candy Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54254495170870': { // High School, Fall, & Halloween Bundle (Inserts Only)
    components: [
      { variantId: '54221346898230', quantity: 1 }, // First Day Of High School Yardsy Sign
      { variantId: '49600085295414', quantity: 1 }, // Welcome Pumpkins Autumn Yardsy Sign
      { variantId: '52360467677494', quantity: 1 }, // Turkey And Touchdowns Yardsy Sign
      { variantId: '50303745294646', quantity: 1 } // Skeleton Boogie Halloween Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373120966966': { // University of Michigan Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51956862878006', quantity: 1 }, // Michigan M Yardsy Sign
      { variantId: '51956863074614', quantity: 1 }, // Michigan M Go Blue Yardsy Sign
      { variantId: '52980007469366', quantity: 1 }, // Michigan Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997251526966', quantity: 1 } // Michigan Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373146427702': { // South Carolina Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51290313097526', quantity: 1 }, // South Carolina SC Black Yardsy Sign
      { variantId: '53543705542966', quantity: 1 }, // South Carolina Go Gamecocks Garnet Yardsy Sign
      { variantId: '54048973390134', quantity: 1 }, // South Carolina Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048975749430', quantity: 1 } // South Carolina Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373147771190': { // South Carolina Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51290313097526', quantity: 1 }, // South Carolina SC Black Yardsy Sign
      { variantId: '53543705542966', quantity: 1 }, // South Carolina Go Gamecocks Garnet Yardsy Sign
      { variantId: '54048973390134', quantity: 1 }, // South Carolina Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997252575542', quantity: 1 } // South Carolina Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373153243446': { // Arkansas Holiday Bundle (Inserts Only)
    components: [
      { variantId: '51333732073782', quantity: 1 }, // Arkansas Sports Mark White Yardsy Sign
      { variantId: '53509916492086', quantity: 1 }, // Arkansas Go Razorbacks Cardinal Yardsy Sign
      { variantId: '53997268468022', quantity: 1 }, // Arkansas Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048958415158', quantity: 1 } // Arkansas Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373155209526': { // Purdue Holiday Bundle (Inserts Only)
    components: [
      { variantId: '51340824150326', quantity: 1 }, // Purdue P Yardsy Sign
      { variantId: '54048971161910', quantity: 1 }, // Purdue P Boiler Up Black Yardsy Sign
      { variantId: '54048969195830', quantity: 1 }, // Purdue Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048969589046', quantity: 1 } // Purdue Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373157536054': { // Montana Holiday Bundle (Inserts Only)
    components: [
      { variantId: '51318614917430', quantity: 1 }, // Montana State Griz White Yardsy Sign
      { variantId: '51318614950198', quantity: 1 }, // Montana Get Your Griz On Mark White Yardsy Sign
      { variantId: '54048964346166', quantity: 1 }, // Montana Halloween Trick Or Treat Yardsy Sign
      { variantId: '54048965230902', quantity: 1 } // Montana Happy Holidays Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373159698742': { // Michigan State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450479968566', quantity: 1 }, // Michigan State S Yardsy Sign
      { variantId: '51450479739190', quantity: 1 }, // Michigan State Helmet Spartans White Yardsy Sign
      { variantId: '53997285048630', quantity: 1 }, // Michigan State Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997285867830', quantity: 1 } // Michigan State Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373160714550': { // Michigan State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51450479968566', quantity: 1 }, // Michigan State S Yardsy Sign
      { variantId: '51450479739190', quantity: 1 }, // Michigan State Helmet Spartans White Yardsy Sign
      { variantId: '53997285048630', quantity: 1 }, // Michigan State Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997251625270', quantity: 1 } // Michigan State Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373164056886': { // West Virginia Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51315431866678', quantity: 1 }, // West Virginia Mountaineers Mark Gold Yardsy Sign
      { variantId: '51315431899446', quantity: 1 }, // West Virginia Mountaineers Wordmark Blue Yardsy Sign
      { variantId: '53997300252982', quantity: 1 }, // West Virginia Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997302382902', quantity: 1 } // West Virginia Merry Christmas Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54373168087350': { // West Virginia Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51315431866678', quantity: 1 }, // West Virginia Mountaineers Mark Gold Yardsy Sign
      { variantId: '51315431899446', quantity: 1 }, // West Virginia Mountaineers Wordmark Blue Yardsy Sign
      { variantId: '53997300252982', quantity: 1 }, // West Virginia Halloween Trick Or Treat Yardsy Sign
      { variantId: '53997254902070', quantity: 1 } // West Virginia Happy Hanukkah Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54504864874806': { // Year-Round Bestsellers Bundle (Inserts Only)
    components: [
      { variantId: '53288130838838', quantity: 1 }, // Happy Valentine's Day Heart Yardsy Sign
      { variantId: '48937634464054', quantity: 1 }, // USA Flag Yardsy Sign
      { variantId: '52360467841334', quantity: 1 }, // Happy Thanksgiving Pumpkin Arrangement Yardsy Sign
      { variantId: '52462625653046', quantity: 1 } // Oh Come Let Us Adore Him Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578774507830': { // Classic Christmas Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475611341110', quantity: 1 }, // Grateful Thankful Blessed Yardsy Sign
      { variantId: '49416311374134', quantity: 1 }, // Merry Christmas Ornaments Holiday Yardsy Sign
      { variantId: '54478114816310', quantity: 1 }, // Hello Winter Snowy Forest Custom Yardsy Sign
      { variantId: '54475611210038', quantity: 1 } // Cheers To The New Year Confetti Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578775294262': { // Festive Holiday Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475618582838', quantity: 1 }, // Merry Christmas Playful Trees Yardsy Sign
      { variantId: '54475612946742', quantity: 1 }, // Happy New Year Toast Yardsy Sign
      { variantId: '53288130773302', quantity: 1 }, // Happy Valentines Day Floral Yardsy Sign
      { variantId: '53492821721398', quantity: 1 } // Happy St. Patrick's Day Shamrock Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578775753014': { // Holiday Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475611242806', quantity: 1 }, // Give Thanks Leaves Yardsy Sign
      { variantId: '54475617042742', quantity: 1 }, // Joy To The World Ornaments Yardsy Sign
      { variantId: '54475611144502', quantity: 1 }, // Art Deco 2027 Yardsy Sign
      { variantId: '53492808810806', quantity: 1 } // Happy Valentine's Day Candy Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578775982390': { // Playful Sayings Holiday Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475620974902', quantity: 1 }, // Thankful For Pie And Yoga Pants Yardsy Sign
      { variantId: '54475616846134', quantity: 1 }, // Jingle All The Way Yardsy Sign
      { variantId: '54475620057398', quantity: 1 }, // Snow Much Fun Yardsy Sign
      { variantId: '54475611210038', quantity: 1 } // Cheers To The New Year Confetti Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578776113462': { // Hanukkah Bundle - Playful 2.0 (Inserts Only)
    components: [
      { variantId: '54475620974902', quantity: 1 }, // Thankful For Pie And Yoga Pants Yardsy Sign
      { variantId: '54475617370422', quantity: 1 }, // Let's Get Lit Yardsy Sign
      { variantId: '54475620057398', quantity: 1 }, // Snow Much Fun Yardsy Sign
      { variantId: '54475612946742', quantity: 1 } // Happy New Year Toast Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578777063734': { // Kwanzaa Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475611242806', quantity: 1 }, // Give Thanks Leaves Yardsy Sign
      { variantId: '54475616616758', quantity: 1 }, // Heri Za Kwanzaa Yardsy Sign
      { variantId: '54475613372726', quantity: 1 }, // Hello Winter Snowy Forest Yardsy Sign
      { variantId: '54475611144502', quantity: 1 } // Art Deco 2027 Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578777325878': { // Classic Hanukkah Bundle 2.0 (Inserts Only)
    components: [
      { variantId: '54475619696950', quantity: 1 }, // Season Of Thanks Arrangement Yardsy Sign
      { variantId: '54475612684598', quantity: 1 }, // Happy Hanukkah Menorah Yardsy Sign
      { variantId: '54475613372726', quantity: 1 }, // Hello Winter Snowy Forest Yardsy Sign
      { variantId: '54475611210038', quantity: 1 } // Cheers To The New Year Confetti Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54578777915702': { // Diwali Bundle (Inserts Only)
    components: [
      { variantId: '54475611275574', quantity: 1 }, // Grateful For Every Little Thing Yardsy Sign
      { variantId: '54475612619062', quantity: 1 }, // Happy Diwali Festival Of Lights Yardsy Sign
      { variantId: '54475613372726', quantity: 1 }, // Hello Winter Snowy Forest Yardsy Sign
      { variantId: '54475611144502', quantity: 1 } // Art Deco 2027 Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585265586486': { // North Dakota State University Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51749619663158', quantity: 1 }, // North Dakota State NDSU Green Yardsy Sign
      { variantId: '54351218377014', quantity: 1 }, // North Dakota Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351219720502', quantity: 1 }, // North Dakota Merry Christmas Yardsy Sign
      { variantId: '54351219654966', quantity: 1 } // North Dakota Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585270272310': { // North Dakota State University Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51749619663158', quantity: 1 }, // North Dakota State NDSU Green Yardsy Sign
      { variantId: '54351218377014', quantity: 1 }, // North Dakota Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351219228982', quantity: 1 }, // North Dakota Happy Hanukkah Yardsy Sign
      { variantId: '54351219654966', quantity: 1 } // North Dakota Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585285607734': { // Brigham Young Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51317664612662', quantity: 1 }, // Brigham Young BYU Mark White Yardsy Sign
      { variantId: '54351134982454', quantity: 1 }, // Brigham Young Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351136981302', quantity: 1 }, // Brigham Young Merry Christmas Yardsy Sign
      { variantId: '54351135703350', quantity: 1 } // Brigham Young Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585306743094': { // Brigham Young Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51317664612662', quantity: 1 }, // Brigham Young BYU Mark White Yardsy Sign
      { variantId: '54351134982454', quantity: 1 }, // Brigham Young Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351135605046', quantity: 1 }, // Brigham Young Happy Hanukkah Yardsy Sign
      { variantId: '54351135703350', quantity: 1 } // Brigham Young Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585404653878': { // Brigham Young Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51317664612662', quantity: 1 }, // Brigham Young BYU Mark White Yardsy Sign
      { variantId: '54351134982454', quantity: 1 }, // Brigham Young Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351135605046', quantity: 1 }, // Brigham Young Happy Hanukkah Yardsy Sign
      { variantId: '54351135703350', quantity: 1 } // Brigham Young Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585493061942': { // Mississippi Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51333144903990', quantity: 1 }, // Mississippi Ole Miss Powder Blue Yardsy Sign
      { variantId: '54351211331894', quantity: 1 }, // Mississippi Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351215100214', quantity: 1 }, // Mississippi Merry Christmas Yardsy Sign
      { variantId: '54351213330742', quantity: 1 } // Mississippi Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585494012214': { // Mississippi Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51333144903990', quantity: 1 }, // Mississippi Ole Miss Powder Blue Yardsy Sign
      { variantId: '54351211331894', quantity: 1 }, // Mississippi Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351211594038', quantity: 1 }, // Mississippi Happy Hanukkah Yardsy Sign
      { variantId: '54351213330742', quantity: 1 } // Mississippi Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585495683382': { // Georgia Tech Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51315399065910', quantity: 1 }, // Georgia Tech Athletics Wordmark Yardsy Sign
      { variantId: '54351153365302', quantity: 1 }, // Georgia Tech Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351166406966', quantity: 1 }, // Georgia Tech Merry Christmas Yardsy Sign
      { variantId: '54351166275894', quantity: 1 } // Georgia Tech Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585496568118': { // Georgia Tech Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51315399065910', quantity: 1 }, // Georgia Tech Athletics Wordmark Yardsy Sign
      { variantId: '54351153365302', quantity: 1 }, // Georgia Tech Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351166079286', quantity: 1 }, // Georgia Tech Happy Hanukkah Yardsy Sign
      { variantId: '54351166275894', quantity: 1 } // Georgia Tech Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585498108214': { // Montana State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51749760696630', quantity: 1 }, // Montana State Bobcats Blue Yardsy Sign
      { variantId: '54351215591734', quantity: 1 }, // Montana State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351216542006', quantity: 1 }, // Montana State Merry Christmas Yardsy Sign
      { variantId: '54351216312630', quantity: 1 } // Montana State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585499124022': { // Montana State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51749760696630', quantity: 1 }, // Montana State Bobcats Blue Yardsy Sign
      { variantId: '54351215591734', quantity: 1 }, // Montana State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351215886646', quantity: 1 }, // Montana State Happy Hanukkah Yardsy Sign
      { variantId: '54351216312630', quantity: 1 } // Montana State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585500565814': { // Virginia Tech Holidays Bundle (Inserts Only)
    components: [
      { variantId: '51332919722294', quantity: 1 }, // Virginia Tech VT Athletics Mark Maroon Yardsy Sign
      { variantId: '54351342698806', quantity: 1 }, // Virginia Tech Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351343616310', quantity: 1 }, // Virginia Tech Happy Holidays Yardsy Sign
      { variantId: '54351343714614', quantity: 1 } // Virginia Tech Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585502400822': { // Arizona State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51866467139894', quantity: 1 }, // Arizona State ASU Trident White Yardsy Sign
      { variantId: '54351128363318', quantity: 1 }, // Arizona State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351130591542', quantity: 1 }, // Arizona State Merry Christmas Yardsy Sign
      { variantId: '54351129313590', quantity: 1 } // Arizona State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585503580470': { // Arizona State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51866467139894', quantity: 1 }, // Arizona State ASU Trident White Yardsy Sign
      { variantId: '54351128363318', quantity: 1 }, // Arizona State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351128756534', quantity: 1 }, // Arizona State Happy Hanukkah Yardsy Sign
      { variantId: '54351129313590', quantity: 1 } // Arizona State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585505906998': { // Indiana Christmas Bundle (Inserts Only)
    components: [
      { variantId: '53391816753462', quantity: 1 }, // Indiana University IU Crimson Yardsy Sign
      { variantId: '53391816818998', quantity: 1 }, // Indiana University Halloween Trick Or Treat Yardsy Sign
      { variantId: '53391816851766', quantity: 1 }, // Indiana University Merry Christmas Yardsy Sign
      { variantId: '53391816917302', quantity: 1 } // Indiana University Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585513607478': { // Washington State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450311049526', quantity: 1 }, // Washington State Primary Mark Crimson Yardsy Sign
      { variantId: '54351344042294', quantity: 1 }, // Washington State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351348203830', quantity: 1 }, // Washington State Merry Christmas Yardsy Sign
      { variantId: '54351346696502', quantity: 1 } // Washington State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585514524982': { // Washington State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51450311049526', quantity: 1 }, // Washington State Primary Mark Crimson Yardsy Sign
      { variantId: '54351344042294', quantity: 1 }, // Washington State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351344566582', quantity: 1 }, // Washington State Happy Hanukkah Yardsy Sign
      { variantId: '54351346696502', quantity: 1 } // Washington State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585517965622': { // Southern Methodist University Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51604003324214', quantity: 1 }, // SMU Mustang Red Blue Yardsy Sign
      { variantId: '54351236825398', quantity: 1 }, // Southern Methodist Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351240462646', quantity: 1 }, // Southern Methodist Merry Christmas Yardsy Sign
      { variantId: '54351239086390', quantity: 1 } // Southern Methodist Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585525961014': { // Southern Methodist University Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51604003324214', quantity: 1 }, // SMU Mustang Red Blue Yardsy Sign
      { variantId: '54351236825398', quantity: 1 }, // Southern Methodist Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351237447990', quantity: 1 }, // Southern Methodist Happy Hanukkah Yardsy Sign
      { variantId: '54351239086390', quantity: 1 } // Southern Methodist Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585527566646': { // North Carolina State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51603864486198', quantity: 1 }, // NCS Wolfpack Red Yardsy Sign
      { variantId: '54351216705846', quantity: 1 }, // NCS Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351217983798', quantity: 1 }, // NCS Merry Christmas Yardsy Sign
      { variantId: '54351216935222', quantity: 1 } // NCS Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585531531574': { // North Carolina State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51603864486198', quantity: 1 }, // NCS Wolfpack Red Yardsy Sign
      { variantId: '54351216705846', quantity: 1 }, // NCS Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351216738614', quantity: 1 }, // NCS Happy Hanukkah Yardsy Sign
      { variantId: '54351216935222', quantity: 1 } // NCS Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585533301046': { // Central Florida Holidays Bundle (Inserts Only)
    components: [
      { variantId: '51315360760118', quantity: 1 }, // UCF Athletics Mark Black Yardsy Sign
      { variantId: '54483016450358', quantity: 1 }, // Central Florida Halloween Trick Or Treat Yardsy Sign
      { variantId: '54483017761078', quantity: 1 }, // Central Florida Happy Holidays Yardsy Sign
      { variantId: '54483018023222', quantity: 1 } // Central Florida Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585537331510': { // Pittsburgh Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450561855798', quantity: 1 }, // Pittsburgh Pitt Paw Game Royal Yardsy Sign
      { variantId: '54351221653814', quantity: 1 }, // Pittsburgh Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351222866230', quantity: 1 }, // Pittsburgh Merry Christmas Yardsy Sign
      { variantId: '54351222341942', quantity: 1 } // Pittsburgh Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585545982262': { // Pittsburgh Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51450561855798', quantity: 1 }, // Pittsburgh Pitt Paw Game Royal Yardsy Sign
      { variantId: '54351221653814', quantity: 1 }, // Pittsburgh Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351221850422', quantity: 1 }, // Pittsburgh Happy Hanukkah Yardsy Sign
      { variantId: '54351222341942', quantity: 1 } // Pittsburgh Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585548276022': { // Memphis Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51600862249270', quantity: 1 }, // Memphis M Tiger Blue Yardsy Sign
      { variantId: '54351201337654', quantity: 1 }, // Memphis Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351205269814', quantity: 1 }, // Memphis Merry Christmas Yardsy Sign
      { variantId: '54351202189622', quantity: 1 } // Memphis Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585550602550': { // Memphis Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51600862249270', quantity: 1 }, // Memphis M Tiger Blue Yardsy Sign
      { variantId: '54351201337654', quantity: 1 }, // Memphis Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351201960246', quantity: 1 }, // Memphis Happy Hanukkah Yardsy Sign
      { variantId: '54351202189622', quantity: 1 } // Memphis Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585552011574': { // Iowa State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '53502197563702', quantity: 1 }, // Iowa State Go Cyclones Cardinal Yardsy Sign
      { variantId: '54351189803318', quantity: 1 }, // Iowa State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351191408950', quantity: 1 }, // Iowa State Merry Christmas Yardsy Sign
      { variantId: '54351190622518', quantity: 1 } // Iowa State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585552994614': { // Iowa State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '53502197563702', quantity: 1 }, // Iowa State Go Cyclones Cardinal Yardsy Sign
      { variantId: '54351189803318', quantity: 1 }, // Iowa State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351190491446', quantity: 1 }, // Iowa State Happy Hanukkah Yardsy Sign
      { variantId: '54351190622518', quantity: 1 } // Iowa State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585559417142': { // Colorado State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51590390317366', quantity: 1 }, // Colorado State Helmet White Yardsy Sign
      { variantId: '54351143698742', quantity: 1 }, // Colorado State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351146680630', quantity: 1 }, // Colorado State Merry Christmas Yardsy Sign
      { variantId: '54351145697590', quantity: 1 } // Colorado State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585560301878': { // Colorado State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51590390317366', quantity: 1 }, // Colorado State Helmet White Yardsy Sign
      { variantId: '54351143698742', quantity: 1 }, // Colorado State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351145468214', quantity: 1 }, // Colorado State Happy Hanukkah Yardsy Sign
      { variantId: '54351145697590', quantity: 1 } // Colorado State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585562104118': { // Oregon State Holidays Bundle (Inserts Only)
    components: [
      { variantId: '51317685846326', quantity: 1 }, // Oregon State Beavers Mascot Yardsy Sign
      { variantId: '54351220212022', quantity: 1 }, // Oregon State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351220277558', quantity: 1 }, // Oregon State Happy Holidays Yardsy Sign
      { variantId: '54351221031222', quantity: 1 } // Oregon State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585564561718': { // Gonzaga Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51317840609590', quantity: 1 }, // Gonzaga Zags Blue Yardsy Sign
      { variantId: '54351166865718', quantity: 1 }, // Gonzaga Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351184494902', quantity: 1 }, // Gonzaga Merry Christmas Yardsy Sign
      { variantId: '54351168078134', quantity: 1 } // Gonzaga Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585565544758': { // Gonzaga Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51317840609590', quantity: 1 }, // Gonzaga Zags Blue Yardsy Sign
      { variantId: '54351166865718', quantity: 1 }, // Gonzaga Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351167095094', quantity: 1 }, // Gonzaga Happy Hanukkah Yardsy Sign
      { variantId: '54351168078134', quantity: 1 } // Gonzaga Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585567281462': { // Boise State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51317712847158', quantity: 1 }, // Boise State Broncos Primary Mark Yardsy Sign
      { variantId: '54351131279670', quantity: 1 }, // Boise State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351134753078', quantity: 1 }, // Boise State Merry Christmas Yardsy Sign
      { variantId: '54351134130486', quantity: 1 } // Boise State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585568166198': { // Boise State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51317712847158', quantity: 1 }, // Boise State Broncos Primary Mark Yardsy Sign
      { variantId: '54351131279670', quantity: 1 }, // Boise State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351133802806', quantity: 1 }, // Boise State Happy Hanukkah Yardsy Sign
      { variantId: '54351134130486', quantity: 1 } // Boise State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585570296118': { // Illinois State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51749258330422', quantity: 1 }, // Illinois State Redbirds Mascot Red Yardsy Sign
      { variantId: '54351188558134', quantity: 1 }, // Illinois State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351189475638', quantity: 1 }, // Illinois State Merry Christmas Yardsy Sign
      { variantId: '54351189147958', quantity: 1 } // Illinois State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585570984246': { // Illinois State Hanukkah Bundle (Insert Only)
    components: [
      { variantId: '51749258330422', quantity: 1 }, // Illinois State Redbirds Mascot Red Yardsy Sign
      { variantId: '54351188558134', quantity: 1 }, // Illinois State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351188754742', quantity: 1 }, // Illinois State Happy Hanukkah Yardsy Sign
      { variantId: '54351189147958', quantity: 1 } // Illinois State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585578684726': { // Syracuse Holidays Bundle (Inserts Only)
    components: [
      { variantId: '50303808569654', quantity: 1 }, // Syracuse University Mascot Blue Yardsy Sign
      { variantId: '54483002655030', quantity: 1 }, // Syracuse Halloween Trick Or Treat Yardsy Sign
      { variantId: '54483003277622', quantity: 1 }, // Syracuse Happy Holidays Yardsy Sign
      { variantId: '54483004916022', quantity: 1 } // Syracuse Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585588252982': { // Texas State Christmas Bundle (Inserts Only)
    components: [
      { variantId: '51600622813494', quantity: 1 }, // Texas State SuperCat Maroon Yardsy Sign
      { variantId: '54351245017398', quantity: 1 }, // Texas State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351259271478', quantity: 1 }, // Texas State Merry Christmas Yardsy Sign
      { variantId: '54351257010486', quantity: 1 } // Texas State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585590120758': { // Texas State Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '51600622813494', quantity: 1 }, // Texas State SuperCat Maroon Yardsy Sign
      { variantId: '54351245017398', quantity: 1 }, // Texas State Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351256846646', quantity: 1 }, // Texas State Happy Hanukkah Yardsy Sign
      { variantId: '54351257010486', quantity: 1 } // Texas State Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585596281142': { // UConn Christmas Bundle (Inserts Only)
    components: [
      { variantId: '50313271542070', quantity: 1 }, // Huskies UConn Color Block Yardsy Sign
      { variantId: '54351271526710', quantity: 1 }, // UConn Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351280374070', quantity: 1 }, // UConn Merry Christmas Yardsy Sign
      { variantId: '54351274803510', quantity: 1 } // UConn Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  '54585597952310': { // UConn Hanukkah Bundle (Inserts Only)
    components: [
      { variantId: '50313271542070', quantity: 1 }, // Huskies UConn Color Block Yardsy Sign
      { variantId: '54351271526710', quantity: 1 }, // UConn Halloween Trick Or Treat Yardsy Sign
      { variantId: '54351273853238', quantity: 1 }, // UConn Happy Hanukkah Yardsy Sign
      { variantId: '54351274803510', quantity: 1 } // UConn Hello Winter Yardsy Sign
    ],
    includeFrame: false  // Inserts only, no frame
  },
  // Future bundles:
  // For bundles WITH frame, set includeFrame: true
  // Example:
  // 'VARIANT_ID': {
  //   components: [...],
  //   includeFrame: true
  // }
};

if (typeof ProductForm !== "function") {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.cartType = this.hasAttribute("data-ajax-cart") ? "ajax" : "page";
      this.isCustom = this.hasAttribute("data-custom-product");
      this.isSemiCustom = this.hasAttribute("data-semi-custom");
      this.isSingleItem = this.hasAttribute("data-single-item");

      this.lumilawnId = this.querySelector(`input[name='lumilawn-id']`)?.value
      this.lumilawnVariantId = this.querySelector(`input[name='lumilawn-variant-id']`)?.value

      // Single-item products (like Lumilawn) never add a stand
      this.addStand = this.isSingleItem ? false : sessionStorage.getItem("kitMode") !== "false";
      this.onCheckChanged(this.addStand);
      this.querySelectorAll(
        '[name="kit-selection-elm"]'
      ).forEach(elm => {
        elm.checked = elm.value === this.addStand.toString();
        elm.addEventListener("change", (event) => {
          this.onCheckChanged(event.target.checked.toString() === event.target.value);
          this.updateInsertsOnlyWarning();
        });
        // todo: why does safari need this :sob:
        elm.addEventListener("touchend", (event) => {
          this.onCheckChanged(event.target.checked.toString() === event.target.value);
          this.updateInsertsOnlyWarning();
        });
      });
      
      // Initialize warning visibility on page load
      this.updateInsertsOnlyWarning();

      if (
        !document.body.classList.contains("template-cart") ||
        this.hasAttribute("data-force-form")
      ) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }
      if (document.body.classList.contains("touchevents")) {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener("touchend", (e) => {
            //submitButton.click();
          });
        }
      }
      this.setPdPVisited();

      if (this.isCustom) {
        if(undefined === window.customilyShopify)
          window.customilyShopify = {};

        window.customilyShopify.useCartDrawerOnEdit = true;
        // window.customilyShopify.ignoreGalleryPositioning = true;
      }
    }

    setPdPVisited() {
      const url = document.querySelector('head > meta[property="og:url"]')?.content;

      // make sure this is a product
      if (!url.indexOf('/products/') < 0)
        return;

      const handle = url?.substring(url.lastIndexOf('/') + 1);

      if (!handle)
        return;

      const recentlyVisited = localStorage.getItem('recently_viewed');
      if (recentlyVisited == null) {
        localStorage.setItem('recently_viewed', JSON.stringify([handle]));
        return;
      }

      let visited = JSON.parse(recentlyVisited)
      const revisitIndex =  visited.indexOf(handle);

      if(revisitIndex > -1) {
        visited.splice(revisitIndex, 1);
      }
      if(visited.length > 12 ) {
        visited.pop();
      }

      visited = [handle, ...visited];
      localStorage.setItem('recently_viewed', JSON.stringify(visited));
    }

    onCheckChanged(addStand) {
      sessionStorage.setItem("kitMode", addStand);
      this.addStand = addStand;
      this.classList.toggle("product-display-kit", addStand);
      this.classList.toggle("product-display-item", !addStand);

      document.querySelectorAll('discount-tracker').forEach(tracker =>{
        tracker.classList.toggle("product-display-kit", addStand);
        tracker.classList.toggle("product-display-item", !addStand);
      });
    }


    onSubmitHandler(e) {
      e.preventDefault();

      this.submitButton = e.submitter;
      this.submitButton.classList.add("working");

      const body = this._serializeForm(this.form, this.addStand);
      
      // Check if this is a bundle that needs to be expanded
      if (body.items && body.items.length > 0) {
        const variantId = body.items[0].id.toString();
        console.log('[Bundle Debug] Variant ID:', variantId);
        console.log('[Bundle Debug] Available bundles:', Object.keys(BUNDLE_CONFIGS));
        const bundleConfig = BUNDLE_CONFIGS[variantId];
        
        if (bundleConfig) {
          console.log('[Bundle Debug] Found bundle config:', bundleConfig);
          // This is a bundle - add components instead
          return this.addBundleComponents(bundleConfig.components, body.items[0].quantity || 1, bundleConfig.includeFrame);
        } else {
          console.log('[Bundle Debug] No bundle config found for this variant');
        }
      }
      
      if (this.isCustom) {
        if (!this.validateCustomilyInputs()) {
          this.submitButton.classList.remove("working");
          return;
        }
        return this.proofCheck(body);
      }

      return this.doAddToCart(body);
    }

    addBundleComponents(components, bundleQuantity, includeFrame) {
      console.log('[Bundle Debug] addBundleComponents called');
      console.log('[Bundle Debug] Components:', components);
      console.log('[Bundle Debug] Bundle quantity:', bundleQuantity);
      
      // Build the items array with all component variants
      const items = components.map(comp => ({
        id: comp.variantId,
        quantity: comp.quantity * bundleQuantity
      }));

      // Add frame if this bundle includes it
      if (includeFrame && this.lumilawnVariantId) {
        items.push({
          id: this.lumilawnVariantId,
          quantity: bundleQuantity
        });
      }

      const body = { items: items };
      console.log('[Bundle Debug] Final cart body:', JSON.stringify(body, null, 2));
      
      return this.doAddToCart(body);
    }

    validateCustomilyInputs() {
      const textInputs = document.querySelectorAll('.customily_option input[type="text"], .customily_option textarea');
      if (textInputs.length === 0) return true;

      for (const input of textInputs) {
        if (input.value.trim() === '') {
          input.style.outline = '2px solid red';
          input.addEventListener('input', () => { input.style.outline = ''; }, { once: true });
        }
      }

      const hasEmpty = Array.from(textInputs).some(input => input.value.trim() === '');
      if (hasEmpty) {
        const container = document.querySelector('.customily-options-container');
        if (container) container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        alert('Please fill in all customization fields before adding to cart.');
        return false;
      }

      return true;
    }

    proofCheck(body) {
      let modal = document.getElementById('proof-popup')
      if (modal == null) {
        //if we can't find it, the feature must be disabled so just add to cart
        return this.doAddToCart(body);
      }

      modal.querySelector('#proof-ack').checked = false;
      modal.querySelector('[data-js-proof-approve]').classList.toggle('disabled', true);

      let proof_img = document.getElementById('proof-img');
      let spinner = document.getElementById('preview-spinner');

      spinner.style.display = '';
      proof_img.style.display= 'none';

      proof_img.onload = function () {
        proof_img.style.display = '';
        spinner.style.display= 'none';
      }

      const originalCanvas = document.querySelector('#preview-canvas');

      // Legacy custom mockups embed the design in a fixed sub-rectangle of the
      // canvas, so we crop to it. Newer semi-custom templates render the design
      // full-bleed — cropping that rectangle chops it to the upper-left, so show
      // the whole canvas instead (what the customer actually gets).
      let offsetX, offsetY, width, height;
      if (this.isSemiCustom) {
        offsetX = 0;
        offsetY = 0;
        width = originalCanvas.width;
        height = originalCanvas.height;
      } else {
        offsetX = originalCanvas.width * 0.03;
        offsetY = originalCanvas.height * 0.05;
        width = originalCanvas.width * 0.64;
        height = originalCanvas.height * 0.88;
      }

      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(originalCanvas,offsetX,offsetY, width,height,0,0,width, height);

      document.getElementById('proof-img').src = canvas.toDataURL();

      modal.querySelector('[data-js-proof-approve]').onclick = () => this.doAddToCart(body);
      modal.show();
    }

    doAddToCart(body) {
      console.log('[Bundle Debug] doAddToCart called with:', JSON.stringify(body));
      let alert = "";
      return fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
        .then((response) => response.json())
        .then((response) => {
          console.log('[Bundle Debug] Cart API response:', response);
          if (response.status === 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.className = "alert alert--error";
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
            if (this.cartType === "page") {
              if (
                document.getElementById("product-page-form-error-cart-alert")
              ) {
                document
                  .getElementById("product-page-form-error-cart-alert")
                  .remove();
              }
              alert.style.marginTop = "1em";
              alert.style.marginBottom = "0";
              alert.id = "product-page-form-error-cart-alert";
              this.form.parentElement.append(alert);
              return false;
            }
            return fetch("?section_id=helper-cart");
          } else {
            if (this.cartType === "page") {
              document.location.href = KROWN.settings.routes.cart_url;
              return false;
            } else {
              return fetch("?section_id=helper-cart");
            }
          }
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          if (alert !== "") {
            document
              .getElementById("AjaxCartForm")
              .querySelector("form")
              .prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-count]"
              ).textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total]")
            .forEach((elm) => {
              elm.textContent = document.querySelector(
                "#AjaxCartForm [data-cart-total]"
              ).textContent;
            });

          document
            .querySelectorAll('shipping-notice')
            .forEach(elm => {
              elm.setAttribute('data-cart-total', cartItems.querySelector('[data-cart-total-raw]').textContent);
              elm.init();
          });
          document
            .querySelectorAll('discount-tracker')
            .forEach(elm => {
              elm.setAttribute('data-num-prints', cartItems.querySelector('[data-cart-count-prints]').textContent);
              elm.setAttribute('data-cart-subtotal-raw', cartItems.querySelector('[data-cart-subtotal-raw]').textContent);
              elm.init();
            });


          this.dispatchEvent(this.ADD_TO_CART);

          // a11y
          if (document.getElementById("screen-reader-info")) {
            document.getElementById(
              "screen-reader-info"
            ).innerText = `${KROWN.settings.locales.cart_announcement}`;
            setTimeout(() => {
              document.getElementById("screen-reader-info").innerText = "";
            }, 1000);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.submitButton?.classList.remove("working");
        });
    }

    _serializeForm(form, addStand) {
      let items = [];
      let arr = {};
      Array.prototype.slice.call(form.elements).forEach(function (field) {

        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1 ||
          ["i-have-a-lumilawn", "charity"].indexOf(field.name) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice
            .call(field.options)
            .forEach(function (option) {
              if (!option.selected) return;
              arr[field.name] = option.value;
            });
        }
        else if (field.name === "quantity" && addStand) {
          arr[field.name] = field.defaultValue;
        } else if (field.name.startsWith("properties[")) {
          if (!arr['properties']) arr['properties'] = {};
          const property = field.name.substring(11, field.name.length - 1);
          arr['properties'][property] = field.value;
        } else {
          arr[field.name] = field.value;
        }
      });
      items.push(arr);
      if (addStand) {
        const standItem = {
          id: this.lumilawnVariantId,
          product_id: this.lumilawnId,
          quantity: 1,
        };
        items.push(standItem);
      }

      //if charities are enabled and non-default option selected, add the property
      let charities_select = document.getElementById('charity');
      if (charities_select && charities_select.selectedIndex != 0) {
        if (!items[0]['properties']) items[0]['properties'] = {};
        items[0]['properties']['charity'] = charities_select.value;
      }
      return {items: items};
    }

    updateInsertsOnlyWarning() {
      const warningElement = this.querySelector('[data-js-kit-inserts-only-warning]');
      if (!warningElement) return;

      // Check if "Inserts Only" (value="false") is selected
      const insertsOnlyRadio = this.querySelector('[name="kit-selection-elm"][value="false"]');
      if (insertsOnlyRadio && insertsOnlyRadio.checked) {
        warningElement.style.display = 'block';
      } else {
        warningElement.style.display = 'none';
      }
    }
  }

  if (typeof customElements.get("product-form") == "undefined") {
    customElements.define("product-form", ProductForm);
  }
}